import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import styled from '@xstyled/styled-components';
import { t } from 'ttag';
import NextIcon from '~/assets/icons/next.svg';

const Button = styled.button`
  background: ${p => p.theme.colors.accentDark};
  padding: 0 ${p => p.theme.space.lg};
  height: 40px;
  border-radius: 20px;
  border: none;
  display: flex;
  align-items: center;
  color: #fff;
  position: relative;
  > span {
    padding: 0 15px;
  }
  &:focus {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 25px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }

  &.tmpNextBtn {
    &:focus::after {
      display: none;
    }
  }

  @media ((max-width: 580px) and (max-height: 300px)) {
    padding: 5px 10px;
    width: fit-content;
    height: 25px;

    > span {
      display: none;
      width: 16px;
      padding: 0;
    }
  }
`;

const Next = styled(NextIcon)`
  width: 20px;
`;

const Prev = styled(NextIcon)`
  transform: rotate(180deg);
  width: 20px;
`;

export const NextButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(function NextButton(props, ref) {
  return (
    <Button
      {...props}
      ref={ref}
      title={t`Next slide`}
      aria-label={t`Next slide`}
    >
      <span>{t`Next`}</span>
      <Next aria-hidden="true" focusable="false" />
    </Button>
  );
});

export const NextButtonWithoutText = (
  props: ButtonHTMLAttributes<HTMLButtonElement>
) => (
  <Button
    {...props}
    title={t`Forward`}
    aria-label={t`Forward`}
    className="tmpNextBtn"
  >
    <Next aria-hidden="true" focusable="false" />
  </Button>
);

export const PrevButtonWithoutText = (
  props: ButtonHTMLAttributes<HTMLButtonElement>
) => (
  <Button {...props} title={t`Back`} aria-label={t`Back`}>
    <Prev aria-hidden="true" focusable="false" />
  </Button>
);
